module.exports = __webpack_public_path__ + "img/1724032212362-semprong isan hakim.jpg.daed4d93.webp";